import { LeftOutlined } from '@ant-design/icons';
import { Link, To } from 'react-router-dom';
import { useTranslation } from 'translations/hooks';

import Button from 'ui/button';

interface GoBackButtonProps {
  to: To;
  isMobile: boolean;
}

export const GoBackButton = ({ to, isMobile }: GoBackButtonProps) => {
  const { t } = useTranslation();

  return (
    <Link to={to}>
      <Button
        type={isMobile ? 'link' : 'primary'}
        ghost={!isMobile}
        icon={isMobile ? <LeftOutlined /> : null}
        iconPosition="start"
      >
        {!isMobile ? t('common.go_back') : null}
      </Button>
    </Link>
  );
};
